// client/src/services/notificationAPI.js
import api from './api';

// Get paginated notifications
// params: { page, limit, unreadOnly, type, priority }
export const fetchNotifications = async (params = {}) => {
  const response = await api.get('/notifications', { params });
  return response.data;
};

// Get unread notification count
export const fetchUnreadCount = async () => {
  const response = await api.get('/notifications/unread-count');
  return response.data;
};

// Get weekly agent summary stats
export const fetchAgentSummary = async () => {
  const response = await api.get('/notifications/agent-summary');
  return response.data;
};

// Mark a single notification as read
export const markAsRead = async (id) => {
  const response = await api.put(`/notifications/${id}/read`);
  return response.data;
};

// Mark all notifications as read
export const markAllAsRead = async () => {
  const response = await api.put('/notifications/read-all');
  return response.data;
};

// Delete a notification
export const deleteNotification = async (id) => {
  const response = await api.delete(`/notifications/${id}`);
  return response.data;
};
